if (!customElements.get('astrobrew-home-hero')) {
  customElements.define('astrobrew-home-hero', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.slides.forEach((slide) => {
        slide.inert = slide.hidden;
        slide.setAttribute('aria-hidden', String(slide.hidden));
      });
      this.handlePhotoLoad = () => {
        const naturalHeight = `${this.getBoundingClientRect().height}px`;
        if (this.style.getPropertyValue('--ab-home-natural-height') !== naturalHeight) {
          this.style.setProperty('--ab-home-natural-height', naturalHeight);
        }
        this.positionPhotos();
      };
      this.photoImages = [...this.querySelectorAll('[data-photo-focus-x] .ab-home-hero__media img')];
      this.photoImages.forEach((image) => image.addEventListener('load', this.handlePhotoLoad));
      this.photoObserver = new ResizeObserver(this.handlePhotoLoad);
      this.photoImages.forEach((image) => this.photoObserver.observe(image.parentElement));
      this.positionPhotos();
      this.controls = this.querySelector('[data-controls]');
      if (!this.controls || this.slides.length < 2) return;
      this.index = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.handleClick = (event) => {
        const button = event.target.closest('button');
        if (!button || !this.controls.contains(button)) return;
        if (button.hasAttribute('data-previous')) this.show(this.index - 1);
        else if (button.hasAttribute('data-next')) this.show(this.index + 1);
        else if (button.hasAttribute('data-index')) this.show(Number(button.dataset.index));
      };
      this.controls.addEventListener('click', this.handleClick);
      this.handleBlockSelect = (event) => {
        const selected = this.slides.indexOf(event.target.closest('[data-slide]'));
        if (selected >= 0) {
          this.paused = true;
          this.show(selected);
          this.stopTimer();
        }
      };
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.controls.dataset.ready = '';
      this.startTimer();
    }
    disconnectedCallback() {
      this.stopTimer();
      this.photoObserver?.disconnect();
      this.photoImages?.forEach((image) => image.removeEventListener('load', this.handlePhotoLoad));
      if (!this.controls) return;
      this.controls.removeEventListener('click', this.handleClick);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }
    show(next) {
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        slide.hidden = i !== this.index;
        slide.inert = slide.hidden;
        slide.setAttribute('aria-hidden', String(slide.hidden));
      });
      this.controls.querySelectorAll('[data-index]').forEach((dot, i) => {
        dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
      });
      this.querySelector('[data-current]').textContent = String(this.index + 1).padStart(2, '0');
      this.positionPhotos();
    }
    positionPhotos() {
      const percent = (value, fallback) => Math.min(.99, Math.max(.01, (Number(value) || fallback) / 100));
      const targetX = percent(this.dataset.focusTargetX, 73);
      const targetY = percent(this.dataset.focusTargetY, 48);
      this.photoImages.forEach((image) => {
        const slide = image.closest('[data-slide]');
        const frame = image.parentElement.getBoundingClientRect();
        if (slide.hidden || !frame.width || !frame.height || !image.naturalWidth || !image.naturalHeight) return;
        const focusX = percent(slide.dataset.photoFocusX, 50);
        const focusY = percent(slide.dataset.photoFocusY, 50);
        const coverScale = Math.max(frame.width / image.naturalWidth, frame.height / image.naturalHeight);
        const photoWidth = image.naturalWidth * coverScale;
        const photoHeight = image.naturalHeight * coverScale;
        // Both sides of both axes must cover the frame after subject alignment.
        const focalZoom = Math.max(1,
          targetX * frame.width / (focusX * photoWidth),
          (1 - targetX) * frame.width / ((1 - focusX) * photoWidth),
          targetY * frame.height / (focusY * photoHeight),
          (1 - targetY) * frame.height / ((1 - focusY) * photoHeight));
        const zoomMultiplier = Number(slide.dataset.photoZoom) || 1;
        const zoom = Math.max(1, focalZoom * zoomMultiplier);
        const width = photoWidth * zoom;
        const height = photoHeight * zoom;
        const focalLeft = targetX * frame.width - focusX * width;
        const focalTop = targetY * frame.height - focusY * height;
        const left = zoomMultiplier < 1 ? Math.min(0, Math.max(frame.width - width, focalLeft)) : focalLeft;
        const top = zoomMultiplier < 1 ? Math.min(0, Math.max(frame.height - height, focalTop)) : focalTop;
        image.style.setProperty('--ab-focal-width', `${photoWidth * zoom / frame.width * 100}%`);
        image.style.setProperty('--ab-focal-height', `${photoHeight * zoom / frame.height * 100}%`);
        image.style.setProperty('--ab-focal-left', `${left / frame.width * 100}%`);
        image.style.setProperty('--ab-focal-top', `${top / frame.height * 100}%`);
        image.setAttribute('data-ab-focal-positioned', '');
      });
    }
    startTimer() {
      this.stopTimer();
      if (this.paused) return;
      this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 5200);
    }
    stopTimer() {
      clearInterval(this.timer);
    }
  });
}